// Helper function untuk mendapatkan endpoint berdasarkan role
export const getAuthEndpoint = () => {
  const hostname = window.location.hostname;

  let baseUrl = "";
  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.includes("stagingapp")
  ) {
    // Untuk lokal dan staging
    baseUrl = process.env.VUE_APP_API_BASE_URL;
  } else if (hostname.includes("beautyverse.id")) {
    // Untuk production
    baseUrl = process.env.VUE_APP_PRODUCTION_API_BASE_URL;
  } else {
    // Fallback jika hostname tidak dikenali
    baseUrl = process.env.VUE_APP_API_BASE_URL;
  }

  // Tentukan path berdasarkan subdomain atau testRole untuk localhost
  let authPath = "/v1/admin/auth"; // Default

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    const urlParams = new URLSearchParams(window.location.search);
    const testRole = urlParams.get("role");

    if (testRole) {
      localStorage.setItem("testRole", testRole);
    }

    const role = testRole || "admin";
    switch (role) {
      case "staff":
        authPath = "/v1/staff/auth";
        break;
      case "doctor":
        authPath = "/v1/doctor/auth";
        break;
      case "admin":
      default:
        authPath = "/v1/admin/auth";
        break;
    }
  } else if (hostname.includes("admin.beautyverse.id")) {
    authPath = "/v1/admin/auth";
  } else if (hostname.includes("klinik.beautyverse.id")) {
    authPath = "/v1/staff/auth";
  } else if (hostname.includes("doctor.beautyverse.id")) {
    authPath = "/v1/doctor/auth";
  }

  return baseUrl + authPath;
};

// Helper function untuk mendapatkan role name berdasarkan roleId
export const getRoleName = (roleId) => {
  switch (roleId) {
    case 1:
      return "Super Admin";
    case 2:
      return "Clinic Staff";
    case 3:
      return "Doctor";
    default:
      return "Unknown";
  }
};

// Helper function untuk mendapatkan domain berdasarkan roleId
export const getDomainByRoleId = (roleId) => {
  const hostname = window.location.hostname;
  console.log("getDomainByRoleId Called:");
  console.log("  Hostname:", hostname);
  console.log("  Role ID:", roleId);
  let domain = "";
  let env = "localhost"; // Default to localhost

  if (hostname.includes("stagingapp")) {
    env = "staging";
  } else if (hostname.includes("beautyverse.id")) {
    env = "production";
  }

  switch (env) {
    case "staging":
      switch (roleId) {
        case 1:
          domain = "bv-admin.stagingapp.xyz";
          break;
        case 2:
          domain = "bv-klinik.stagingapp.xyz";
          break;
        case 3:
          domain = "bv-doctor.stagingapp.xyz";
          break;
        default:
          domain = "bv-admin.stagingapp.xyz"; // Fallback
      }
      break;
    case "production":
      switch (roleId) {
        case 1:
          domain = "admin.beautyverse.id";
          break;
        case 2:
          domain = "klinik.beautyverse.id";
          break;
        case 3:
          domain = "doctor.beautyverse.id";
          break;
        default:
          domain = "admin.beautyverse.id"; // Fallback
      }
      break;
    case "localhost":
    default:
      switch (roleId) {
        case 1:
          domain = "localhost:8080";
          break;
        case 2:
          domain = "localhost:8080";
          break;
        case 3:
          domain = "localhost:8080";
          break;
        default:
          domain = "localhost:8080";
      }
      break;
  }
  console.log("  Determined Domain:", domain);
  return domain;
};

// Helper function untuk testing lokal - mendapatkan roleId berdasarkan endpoint
export const getTestRoleId = () => {
  const hostname = window.location.hostname;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    const endpoint = getAuthEndpoint();

    switch (endpoint) {
      case "/v1/staff/auth":
        return 2; // Clinic Staff
      case "/v1/doctor/auth":
        return 3; // Doctor
      case "/v1/admin/auth":
      default:
        return 1; // Super Admin
    }
  }

  return null; // Untuk production, gunakan roleId dari backend
};

// Helper function untuk mengecek apakah sedang di localhost
export const isLocalhost = () => {
  const hostname = window.location.hostname;
  return hostname === "localhost" || hostname === "127.0.0.1";
};

// Helper function to clear testRole from localStorage
export const clearTestRole = () => {
  localStorage.removeItem("testRole");
};
// Helper function untuk mendapatkan endpoint API berdasarkan roleId
export const getApiEndpointByRole = (roleId, service = "orders") => {
  switch (roleId) {
    case 1: // Super Admin
      return `/v1/admin/${service}`;
    case 2: // Staff
      return `/v1/staff/${service}`;
    case 3: // Doctor
      return `/v1/doctor/${service}`;
    default:
      return `/v1/admin/${service}`;
  }
};

// Helper function untuk mengecek apakah user memiliki akses ke orders
export const hasOrderAccess = (roleId) => {
  return roleId === 1 || roleId === 2; // Super Admin atau Staff
};

// Helper function untuk mengecek level akses user
export const getUserAccessLevel = (roleId) => {
  switch (roleId) {
    case 1:
      return "super_admin";
    case 2:
      return "staff";
    case 3:
      return "doctor";
    default:
      return "unknown";
  }
};

// Helper function untuk mendapatkan role prefix berdasarkan roleId
export const getRolePrefix = (roleId) => {
  switch (roleId) {
    case 1:
      return "admin";
    case 2:
      return "staff";
    case 3:
      return "doctor";
    default:
      return "admin";
  }
};

// Helper function to get the full login URL based on the environment and a default role
export const getFullLoginUrl = () => {
  const hostname = window.location.hostname;
  let protocol = window.location.protocol;
  
  // Try to get roleId from localStorage
  let roleId = null;
  const user = localStorage.getItem("user");
  if (user) {
    try {
      const parsedUser = JSON.parse(user);
      roleId = parsedUser.roleId;
    } catch (e) {
      console.error("Error parsing user from localStorage", e);
    }
  }
  
  // Default to Super Admin (roleId 1) if not found or invalid
  const effectiveRoleId = roleId || 1;

  let domain = getDomainByRoleId(effectiveRoleId);

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    // For localhost, getDomainByRoleId already includes the port, e.g., "localhost:8080"
    return `${protocol}//${domain}/login`;
  } else {
    // For staging/production, getDomainByRoleId returns just the domain (e.g., "admin.beautyverse.id")
    return `${protocol}//${domain}/login`;
  }
};

